import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { Config } from "src/app/utility/config";
@Injectable({
  providedIn: "root",
})
export class TimesheetService {
  // getalluser() {
  //   throw new Error('Method not implemented.');
  // }
  getalluser(): Observable<any> {
    this.config.resolveLogin_KeyPromise();
    const url =
      this.config.APIUrl +
      "User/GetAll?Login_Key=" +
      this.config.login_Key +
      "&OnlyActive=" +
      true;
    return this.http
      .post(url, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }
  constructor(private http: HttpClient, private config: Config) {}

  savetimesheet(data: any): Observable<any> {
    this.config.resolveLogin_KeyPromise();
    const url =
      this.config.APIUrl +
      "QRT_Time_Sheet/SaveUpdate?Login_Key=" +
      this.config.login_Key;
    return this.http
      .post(url, data, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }

  saveMultitimesheet(data: any): Observable<any> {
    this.config.resolveLogin_KeyPromise();
    const url =
      this.config.APIUrl +
      "QRT_Time_Sheet/SaveUpdateMulti?Login_Key=" +
      this.config.login_Key;
    return this.http
      .post(url, data, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }

  ResetHours(data: any): Observable<any> {
    this.config.resolveLogin_KeyPromise();
    const url =
      this.config.APIUrl +
      "QRT_Time_Sheet/ResetHours?Login_Key=" +
      this.config.login_Key;
    return this.http
      .post(url, data, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }

  ResetHoursForDate(data: any): Observable<any> {
    this.config.resolveLogin_KeyPromise();
    const url =
      this.config.APIUrl +
      "QRT_Time_Sheet/ResetHoursForDate?Login_Key=" +
      this.config.login_Key;
    return this.http
      .post(url, data, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }

  SubmitTimeSheetStatus(data: any, Status: any): Observable<any> {
    this.config.resolveLogin_KeyPromise();
    const url =
      this.config.APIUrl +
      "QRT_Time_Sheet/SubmitHoursForDate?status=" +
      Status +
      "&Login_Key=" +
      this.config.login_Key;

    return this.http
      .post(url, data, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }

  UpdateTimeSheetStatusForWeek(data: any, Status: any): Observable<any> {
    this.config.resolveLogin_KeyPromise();
    const url =
      this.config.APIUrl +
      "QRT_Time_Sheet/SubmitHoursForDate?status=" +
      Status +
      "&Login_Key=" +
      this.config.login_Key;

    return this.http
      .post(url, data, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }

  SubmitTimeSheetStatusForWeek(
    data: any,
    Status: any,
    comment: any
  ): Observable<any> {
    this.config.resolveLogin_KeyPromise();
    const url =
      this.config.APIUrl +
      "QRT_Time_Sheet/SubmitTimeSheet?Status=" +
      Status +
      "&comment=" +
      comment +
      "&Login_Key=" +
      this.config.login_Key;

    return this.http
      .post(url, data, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }
  GetByprojectsAndDate(
    Employee_Id: number,
    Project: any,
    Date: any
  ): Observable<any> {
    this.config.resolveLogin_KeyPromise();
    const url =
      this.config.APIUrl +
      "QRT_Time_Sheet/GetByProject?Login_Key=" +
      this.config.login_Key +
      "&Employee_Id=" +
      Employee_Id +
      "&Project=" +
      Project +
      "&Date=" +
      Date;
    return this.http
      .get(url, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }

  getalltimesheetforadmin(): Observable<any> {
    this.config.resolveLogin_KeyPromise();
    const url =
      this.config.APIUrl +
      "QRT_Time_Sheet/GetAllTimesheet?Login_Key=" +
      this.config.login_Key;
    return this.http
      .get(url, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }
  GetTimeSheetDataForAdmin(): Observable<any> {
    this.config.resolveLogin_KeyPromise();
    const url =
      this.config.APIUrl +
      "QRT_Time_Sheet/GetAllTimesheetForAdmin?Login_Key=" +
      this.config.login_Key;
    return this.http
      .get(url, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }

  getprojects(): Observable<any> {
    this.config.resolveLogin_KeyPromise();
    const url =
      this.config.APIUrl +
      "QRT_Time_Sheet/GetAllTimesheet?Login_Key=" +
      this.config.login_Key;
    return this.http
      .get(url, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }
  getalltimesheetForEmp(UserId: any): Observable<any> {
    this.config.resolveLogin_KeyPromise();
    const url =
      this.config.APIUrl +
      "QRT_Time_Sheet/GetAllById?Login_Key=" +
      this.config.login_Key +
      "&Id=" +
      UserId;
    return this.http
      .post(url, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }

  gettimesheetByUserId(UserId: any): Observable<any> {
    this.config.resolveLogin_KeyPromise();
    const url =
      this.config.APIUrl +
      "QRT_Time_Sheet/GetDateByUserId?Login_Key=" +
      this.config.login_Key +
      "&UserId=" +
      UserId;
    return this.http
      .post(url, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }

  DeleteById(Id: any): Observable<any> {
    this.config.resolveLogin_KeyPromise();
    const url =
      this.config.APIUrl +
      "QRT_Time_Sheet/Delete?id=" +
      Id +
      "&Login_Key=" +
      this.config.login_Key;

    return this.http
      .post(url, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }

  UpdateStatus(Id: any, Status: any): Observable<any> {
    this.config.resolveLogin_KeyPromise();
    const url =
      this.config.APIUrl +
      "QRT_Time_Sheet/UpdateStatus?Login_Key=" +
      this.config.login_Key +
      "&Id=" +
      Id +
      "&Status=" +
      Status;

    return this.http
      .post(url, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }

  gettimesheet(UserId: any, FromDate: string, toDate: string): Observable<any> {
    this.config.resolveLogin_KeyPromise();
    const url =
      this.config.APIUrl +
      "QRT_Time_Sheet/GetTimeSheetByDates?StartDate=" +
      FromDate +
      "&End_Date=" +
      toDate +
      "&Employee_Id=" +
      UserId;
    return this.http
      .get(url, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }

  GetTimeSheetById(Id: any): Observable<any> {
    const url =
      this.config.APIUrl +
      "QRT_Time_Sheet/GetAllById?Login_Key=" +
      this.config.login_Key +
      "&Id=" +
      Id;

    return this.http
      .post(url, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }

  exporttimesheet(
    employee_Id: any,
    FromDate: string,
    toDate: string,
    format: string
  ): Observable<any> {
    this.config.resolveLogin_KeyPromise();
    const url =
      this.config.APIUrl +
      "QRT_Time_Sheet/ExportTimesheet?Login_Key=" +
      this.config.login_Key +
      "&StartDate=" +
      FromDate +
      "&EndDate=" +
      toDate +
      "&employee_Id=" +
      employee_Id +
      "&Format=" +
      format;
    return this.http
      .get(url, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }

  getTimeSheetByDate(
    Employee_Id: any,
    Start_date: any,
    End_Date: any
  ): Observable<any> {
    const url =
      this.config.APIUrl +
      "Time_Sheet_Projects/GetTimeSheetData?Login_Key=" +
      this.config.login_Key +
      "&Employee_Id=" +
      Employee_Id +
      "&StartDate=" +
      Start_date +
      "&EndDate=" +
      End_Date;

    return this.http
      .post(url, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }

  getTimeSheetSummaryByWeek(
    Employee_Id: any,
    Start_date: any,
    End_Date: any
  ): Observable<any> {
    const url =
      this.config.APIUrl +
      "Time_Sheet_Projects/GetTimeSheetSummaryByWeek?Login_Key=" +
      this.config.login_Key +
      "&Employee_Id=" +
      Employee_Id +
      "&StartDate=" +
      Start_date +
      "&EndDate=" +
      End_Date;
    return this.http
      .post(url, this.config.httpOptions)
      .pipe(catchError(this.config.handleError));
  }
}
